export default __webpack_public_path__ + "static/media/arrow_left_white.3d58610b.svg";